import validate from "/home/runner/work/cabral.ro/cabral.ro/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/cabral.ro/cabral.ro/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "attachment-redirect": () => import("/home/runner/work/cabral.ro/cabral.ro/middleware/attachment-redirect.js"),
  "single-data": () => import("/home/runner/work/cabral.ro/cabral.ro/middleware/single-data.js")
}